export default __webpack_public_path__ + "static/media/472.00cf43ff.jpg";